import Card from 'components/atoms/Card'
import DisplayCard from 'components/DisplayCard'
import React from 'react'
import {useTranslation} from 'react-i18next'

function DescBrainCPage() {
  const {t} = useTranslation()
  const contents = [
    {title: t('IProductName'), content: 'iSyncBrain-C'},
    {title: t('IItemName'), content: t('IEEGAnalysisSoftware')},
    {title: t('IModelName'), content: 'ISB-C-003'},
    {title: t('IManuFacturer'), content: t('IMedisyncInc')},
    {title: t('IAddress'), content: t('IAppCompanyAddress')},
    {title: t('ILicenseNumber'), content: t('ILicenseCodeNumber')},
    {title: t('ICertificationNumber'), content: t('ICertificationBrainC')},
    {title: t('ISerialNumber'), content: t('ISerialVersion')},
    {title: t('IYearOfManufacture'), content: t('IAugustEight')},
    {title: t('IPackagingUnit'), content: t('INotApplicable')},
    {title: t('IPurposeOfUse'), content: t('IPurposeState')},
    {title: t('UDI'), content: '(01)08800108500394'},
  ]
  return (
    <Card>
      <DisplayCard contents={contents} />
    </Card>
  )
}

export default DescBrainCPage
